<template>
    <section>
        <!-- <Pets/> -->
        <!-- <F1/> -->
    </section>
</template>
<script>
import F1 from './components/F1.vue';
import Pets from './components/Pets.vue';


export default {
  props: {},
  components:{Pets,F1},
  data() {
    return {};
  },
  computed: {},
  async mounted() {
   
  },
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/admin/varios/Varios.vue